var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "4" } },
            [
              _c("FormulateInput", {
                attrs: {
                  id: "rate-history-type",
                  type: "vue-select",
                  ignored: "",
                  label: _vm.$t("Tributo"),
                  placeholder: _vm.$t("Todos"),
                  options: _vm.typeOptions,
                },
                model: {
                  value: _vm.filters.type,
                  callback: function ($$v) {
                    _vm.$set(_vm.filters, "type", $$v)
                  },
                  expression: "filters.type",
                },
              }),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { md: "4" } },
            [
              _c("FormulateInput", {
                attrs: {
                  id: "rate-history-period",
                  type: "date-range-picker",
                  ignored: "",
                  "time-picker": false,
                  label: _vm.$t("Vigência"),
                },
                model: {
                  value: _vm.filters.period,
                  callback: function ($$v) {
                    _vm.$set(_vm.filters, "period", $$v)
                  },
                  expression: "filters.period",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("b-table", {
        staticClass: "bordered table-no-minheight",
        attrs: {
          items: _vm.items,
          fields: _vm.fields,
          busy: _vm.fetching,
          small: "",
          "show-empty": "",
          "empty-text": _vm.$t("Nenhuma vigência cadastrada."),
          responsive: "",
          striped: "",
          "tbody-tr-class": _vm.rowClass,
        },
        scopedSlots: _vm._u([
          {
            key: "cell(status)",
            fn: function (ref) {
              var item = ref.item
              return [
                _c(
                  "b-badge",
                  { attrs: { variant: _vm.statusVariant[item.status] } },
                  [_vm._v(" " + _vm._s(_vm.statusLabel[item.status]) + " ")]
                ),
              ]
            },
          },
        ]),
      }),
      _c("small", { staticClass: "text-muted" }, [
        _vm._v(
          " " +
            _vm._s(
              _vm.$t("Somente consulta. Alíquotas de referência por vigência.")
            ) +
            " "
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }